
<div class="form-header">
  <button mat-button class="close-button"
  tabindex="-1" title="Close"
    (click)="close()">
    <img src="assets/content-icon/ic-05.svg" class="icon" />
  </button>
  Edit documents
</div>
<div class="dialog-container" >
  <documents [contextId]="contextId" [contextType]="contextType" [providerId]="providerId"  mode="dialog"></documents>
</div>
